
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Als sich Schauspieler Eddie Redmayne bei einem persönlichen Treffen mit dem
Physiker Stephen Hawking einst auf seine Rolle in dessen Filmbiografie
vorbereitete und freudig darauf hinwies, dass er beste Voraussetzungen für diese
Rolle habe, weil sie im gleichen Sternzeichen geboren seien, antwortete Hawking
nüchtern: «Ich bin ein Astronom. Kein Astrologe.» Der britische Physiker lebte
50 Jahre mit seiner ALS-Erkrankung, und auch da blieb er konsequent
Naturwissenschafter: «Ich halte es durchaus für möglich, dass ich irgendjemanden
dort oben erzürnt habe, aber ich ziehe es doch vor, zu denken, dass alles (...)
durch die Naturgesetze erklärt werden kann.»`}</p>
    <p>{`Das sah der fromme Hiob vor ein paar tausend Jahren ganz anders. Gott war in
seiner Vorstellung ein ansprechbares Du als Gegenüber, das seinen Glauben mit
Schicksalsschlägen solange auf die Probe stellte, bis der Gläubige zur Einsicht
von dessen Allmacht kam: «Ich habe erkannt, dass du alles vermagst, nichts, was
du sinnst, ist dir verwehrt» (Hiob 42, Verse 2 und 3). Die Personalpronomina der
Sonntagsschule sind das kindliche, hilflose Ich und das persönlich ansprechbare,
allmächtige Du.`}</p>
    <p>{`Inzwischen teilt eine grosse Mehrheit in Europa aber Hawkings Sichtweise. Die
klassischen Religionen haben in weiten Teilen der Bevölkerung ihre Bedeutung
verloren und mit ihr die persönliche Ansprechbarkeit Gottes. Das hat mit dem
wachsenden Wohlstand nach dem Übergang von der Agrargesellschaft zur Industrie-
und danach zur Dienstleistungsgesellschaft zu tun. Der Sozialstaat trat
vielerorts an die Stelle der religiösen Versicherung der Existenz. Kam dazu,
dass die Kirche an Einfluss verlor, keine Rechte mehr zu verteilen hatte und
auch kein Monopol mehr auf Angstmacherei. Rationalität und Individualität nahmen
zu. In der religiös und kulturell gemischten Einwanderergesellschaft gibt es die
eine Wahrheit nicht mehr, sondern konkurrierende Wahrheiten, die sich
gegenseitig schwächen.`}</p>
    <p>{`Laut Habermas wurde die Religion in zwei Etappen entzaubert: In der «Achsenzeit»
(so bezeichnete Karl Jaspers die Zeit von 800 bis 200 v. Chr.) entstanden in den
Stadtstaaten die grossen monotheistischen Religionen. Das magische Denken über
Erde, Tiere, Gespenster und strafende Naturgewalten wurde überwunden, die Zahl
der Götter etwa im Judentum und Christentum auf eins reduziert. Im Buddhismus
wurde eine explizite Gottesvorstellung auf dem Weg zur Erleuchtung sogar ganz
überflüssig. Damit war das Pantheon, das über die Jahrhunderte zuvor die
verschiedensten Götter und Naturgeister versammelt hatte, schon recht leer
geworden.`}</p>
    <p>{`Mit der Aufklärung folgte die zweite Entzauberung der Religion, denn nun konnten
und durften zuvor rätselhafte Phänomene wissenschaftlich und logisch erklärt
werden. Neu entstehende Religionen wie der Protestantismus säkularisierten mit
dem Bilderverbot ihr Gottesverständnis. Das Brot, das zum Abendmahl gereicht
wurde, war fortan nur noch ein Symbol für den Leib Christi. So entstand der Raum
für eine Annäherung von Religion und Philosophie, die Philosophie wandte sich
einst der Religion vorbehaltenen Fragen zu, zahlreiche protestantische Theologen
wurden zu Philosophen. Bei einem Denker wie Sören Kierkegaard verschwand diese
Grenze ganz, er wurde zum Existenzphilosophen. Und der protestantische Theologe
Paul Tillich, während der Nazi-Herrschaft in die USA emigriert, entpersönlichte
die Gottesvorstellung: Gott ist die Dimension der Tiefe.`}</p>
    <p>{`Der leer geräumte Himmel ist seither vereinbar mit den Erkenntnissen der
Astronomie. Diese Wissenschaft hatte über die Jahrhunderte ein ganz anderes Bild
des Universums erforscht, als es die Religionen behaupteten. In einem Universum
mit zwei Billionen Galaxien, das vermutlich zehndimensional ist und in der Zeit
eine elfte Dimension hat, ist kein Platz für die Gottesvorstellung aus der
Sonntagsschule. Die Erde ist darin ein winziger Planet unter Milliarden anderer,
und der Physiker Stephen Hawking fragte sich und seine Leser: Warum soll sich
ein Gott in diesem riesigen All ausgerechnet für mich und dich interessieren?`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;